module.exports = __webpack_public_path__ + "media/images/icon_list/table-319bf77eae525d6498151418bb04358a.svg";